var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_17534)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#EDFFF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6905 9.30949C13.6905 10.5197 12.7103 11.5 11.5 11.5C10.2898 11.5 9.30956 10.5197 9.30956 9.30949C9.30956 8.09926 10.2898 7.11902 11.5 7.11902C12.7103 7.11902 13.6905 8.09926 13.6905 9.30949ZM7.11908 14.7857C7.11908 13.329 10.0379 12.5952 11.5 12.5952C12.9622 12.5952 15.881 13.329 15.881 14.7857V15.3333C15.881 15.6345 15.6346 15.8809 15.3334 15.8809H7.6667C7.36551 15.8809 7.11908 15.6345 7.11908 15.3333V14.7857Z",
    fill: "#58DF6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_17534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.bd33114ed5105c5c3ad0076f5102d0d7.svg";
export { ForwardRef as ReactComponent };